import React from "react";
import "./footer.css";
const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer__container container">
        <h1 className="footer__title">SHUBH</h1>

        <div className="footer__social">
          <a
            href="https://www.facebook.com/mr.shubh241"
            className="footer__social-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="bx bxl-facebook"></i>
          </a>
          <a
            href="https://www.instagram.com/shubhamprajapati7748/"
            className="footer__social-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="bx bxl-instagram"></i>
          </a>

          <a
            href="https://twitter.com/0xprajapati"
            className="footer__social-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="bx bxl-twitter"></i>
          </a>
        </div>
      </div>

      <span className="footer__copy">
        Made with 💜 by <i>Shubham Prajapati</i>
      </span>
    </footer>
  );
};

export default Footer;
